import {Component, OnInit, ViewChild} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseView } from '../../../../../core/view/base.view';
import { CreateMessageComponent } from '../../../../../message/api/component/create-message/create-message.component';
import { WorkflowTaskHumanSaveService } from '../../service/workflowTaskHumanSave.service';
import { WorkflowTaskHumanSavePayload } from '../../service/payload/workflowTaskHumanSave.payload';
import { WorkflowTaskModel } from '../../../api/model/common/workflowTask.model';
import { WorkflowTaskFindOneByIdService } from '../../service/workflowTaskFindOneById.service';
import { WorkflowTaskStatus } from '../../../api/model/common/workflowTaskSummary.model';
import {IDialogComponent} from '../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../common/dialog/dialogWithInput';
import {
    CreateUpdateDefaultComponent
} from '../../../../../core/component/create-update-default/create-update-default.component';


export interface WorkflowTaskHumanSaveDialogInput {
    id?: number;
    statusValue?: WorkflowTaskStatus;
}
export interface WorkflowTaskHumanSaveDialogResult{
    entity?: WorkflowTaskModel;
}

@Component({
    templateUrl: './workflow-task-human-save.page.html',
    viewProviders: [
        WorkflowTaskHumanSaveService,
        WorkflowTaskFindOneByIdService]
})
export class WorkflowTaskHumanSavePage extends BaseView implements
    IDialogComponent<WorkflowTaskHumanSaveDialogInput, WorkflowTaskHumanSaveDialogResult>,
    OnInit {
    dialog: DialogWithInput<WorkflowTaskHumanSaveDialogInput, WorkflowTaskHumanSaveDialogResult>;

    formGroup: UntypedFormGroup;
    TaskStatus = WorkflowTaskStatus;
    @ViewChild('initialMessage') createMessageComponent: CreateMessageComponent;
    @ViewChild('createUpdateDefaultComponent') createUpdateDefaultComponent: CreateUpdateDefaultComponent<any, any, any>;

    constructor(
        public service: WorkflowTaskHumanSaveService,
        public findByIdService: WorkflowTaskFindOneByIdService,
        private formBuilder: UntypedFormBuilder) {
        super();
        this.formGroup = this.formBuilder.group({
            summary: new UntypedFormGroup({
                id: new UntypedFormControl(undefined)
            }),
            title: new UntypedFormControl('', Validators.required),
            initialMessageContentToUpdate: new UntypedFormControl(undefined),
            deadline: new UntypedFormControl(''),
            statusValue: this.formBuilder.control(WorkflowTaskStatus.TASK_STATUS_NOT_STARTED, Validators.required),
            assignedUserId: new UntypedFormControl(''),
        });
    }

    ngOnInit(): void {
        if (this.dialog.input.statusValue) {
            this.formGroup.patchValue({
                statusValue: this.dialog.input.statusValue
            });
        }
    }

    buildPayload = (): WorkflowTaskHumanSavePayload => {
        const payload: WorkflowTaskHumanSavePayload = Object.assign(new WorkflowTaskHumanSavePayload(), this.formGroup.value);
        if (!this.formGroup.get('summary.id').value) {
            payload.message = this.createMessageComponent.messageCreatePayload;
        }
        return payload;
    }

    entityLoaded(entity: WorkflowTaskModel) {
        console.log('entityLoaded', entity);
        this.formGroup.patchValue({
            title: entity.summary.label,
            deadline: entity.summary.deadline,
            assignedUserId: entity.summary.assignedUser?.id,
            statusValue: entity.summary.status.value,
            initialMessageContentToUpdate: entity.summary.initialMessageContent !== 'null' ? entity.summary.initialMessageContent : undefined,
            summary: {
                id: entity.summary.id
            }
        });
    }

    entitySaved(entity: WorkflowTaskModel) {
        this.dialog.close({
            entity
        });
    }

    executeSave() {
        this.createUpdateDefaultComponent.save();
    }

}
